import logo from './logo.svg';
import './App.css';
import React, { useState } from 'react';

import UploadForm from './compontents/UploadForm';
import ImageGrid from './compontents/ImageGrid';
import Modal from './compontents/Modal';
import Profile1 from './compontents/Profile1';

function App() {
  const [selectedImg, setSelectedImg] = useState(null);

  return (
    <div className="App">
     
      {/* <UploadForm /> */}
      <Profile1 />
      <ImageGrid setSelectedImg={setSelectedImg} />
      { selectedImg && (
        <Modal selectedImg={selectedImg} setSelectedImg={setSelectedImg} />
      )}
    </div>
  );
      }

export default App;
